import { createContext, useContext } from 'react';

// Couleur d'accent de l'entité courante (Café=jaune, Bureau=bleu, SCI=mint).
// Les composants UI globaux (PageHeader, SectionTitle…) la consomment pour
// teinter discrètement leur affichage. null = pas d'entité (Today, Factures…).
export const EntityAccentContext = createContext(null);
export const useEntityAccent = () => useContext(EntityAccentContext);
